import { render, staticRenderFns } from "./ChatEmotionDetails.vue?vue&type=template&id=0edf2a30&scoped=true"
import script from "./ChatEmotionDetails.vue?vue&type=script&lang=js"
export * from "./ChatEmotionDetails.vue?vue&type=script&lang=js"
import style0 from "./ChatEmotionDetails.vue?vue&type=style&index=0&id=0edf2a30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf2a30",
  null
  
)

export default component.exports